export default __webpack_public_path__ + "static/user1-807a9467b9eadb2c519848a7fe62f8df.png";